
      import { createLanguage, createTranslationFile } from '@vocab/webpack/web';
      
    const translations = createTranslationFile({
      "en": createLanguage(
        require.resolveWeak("./translations.json-en-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJKb2IgaW5mb3JtYXRpb24iOiJKb2IgaW5mb3JtYXRpb24ifQ==!"),
        () => import(
          /* webpackChunkName: "en-translations" */
          "./translations.json-en-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJKb2IgaW5mb3JtYXRpb24iOiJKb2IgaW5mb3JtYXRpb24ifQ==!"
        )
      ),
"th": createLanguage(
        require.resolveWeak("./translations.json-th-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJKb2IgaW5mb3JtYXRpb24iOiLguILguYnguK3guKHguLnguKXguIfguLLguJkifQ==!"),
        () => import(
          /* webpackChunkName: "th-translations" */
          "./translations.json-th-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJKb2IgaW5mb3JtYXRpb24iOiLguILguYnguK3guKHguLnguKXguIfguLLguJkifQ==!"
        )
      ),
"id": createLanguage(
        require.resolveWeak("./translations.json-id-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJKb2IgaW5mb3JtYXRpb24iOiJJbmZvcm1hc2kgcGVrZXJqYWFuIn0=!"),
        () => import(
          /* webpackChunkName: "id-translations" */
          "./translations.json-id-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJKb2IgaW5mb3JtYXRpb24iOiJJbmZvcm1hc2kgcGVrZXJqYWFuIn0=!"
        )
      ),
"zh": createLanguage(
        require.resolveWeak("./translations.json-zh-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJKb2IgaW5mb3JtYXRpb24iOiJKb2IgaW5mb3JtYXRpb24ifQ==!"),
        () => import(
          /* webpackChunkName: "zh-translations" */
          "./translations.json-zh-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJKb2IgaW5mb3JtYXRpb24iOiJKb2IgaW5mb3JtYXRpb24ifQ==!"
        )
      ),
"en-AU": createLanguage(
        require.resolveWeak("./translations.json-en-AU-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJKb2IgaW5mb3JtYXRpb24iOiJKb2IgaW5mb3JtYXRpb24ifQ==!"),
        () => import(
          /* webpackChunkName: "en-AU-translations" */
          "./translations.json-en-AU-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJKb2IgaW5mb3JtYXRpb24iOiJKb2IgaW5mb3JtYXRpb24ifQ==!"
        )
      ),
"en-HK": createLanguage(
        require.resolveWeak("./translations.json-en-HK-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJKb2IgaW5mb3JtYXRpb24iOiJKb2IgaW5mb3JtYXRpb24ifQ==!"),
        () => import(
          /* webpackChunkName: "en-HK-translations" */
          "./translations.json-en-HK-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJKb2IgaW5mb3JtYXRpb24iOiJKb2IgaW5mb3JtYXRpb24ifQ==!"
        )
      ),
"en-ID": createLanguage(
        require.resolveWeak("./translations.json-en-ID-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJKb2IgaW5mb3JtYXRpb24iOiJKb2IgaW5mb3JtYXRpb24ifQ==!"),
        () => import(
          /* webpackChunkName: "en-ID-translations" */
          "./translations.json-en-ID-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJKb2IgaW5mb3JtYXRpb24iOiJKb2IgaW5mb3JtYXRpb24ifQ==!"
        )
      ),
"en-MY": createLanguage(
        require.resolveWeak("./translations.json-en-MY-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJKb2IgaW5mb3JtYXRpb24iOiJKb2IgaW5mb3JtYXRpb24ifQ==!"),
        () => import(
          /* webpackChunkName: "en-MY-translations" */
          "./translations.json-en-MY-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJKb2IgaW5mb3JtYXRpb24iOiJKb2IgaW5mb3JtYXRpb24ifQ==!"
        )
      ),
"en-NZ": createLanguage(
        require.resolveWeak("./translations.json-en-NZ-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJKb2IgaW5mb3JtYXRpb24iOiJKb2IgaW5mb3JtYXRpb24ifQ==!"),
        () => import(
          /* webpackChunkName: "en-NZ-translations" */
          "./translations.json-en-NZ-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJKb2IgaW5mb3JtYXRpb24iOiJKb2IgaW5mb3JtYXRpb24ifQ==!"
        )
      ),
"en-PH": createLanguage(
        require.resolveWeak("./translations.json-en-PH-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJKb2IgaW5mb3JtYXRpb24iOiJKb2IgaW5mb3JtYXRpb24ifQ==!"),
        () => import(
          /* webpackChunkName: "en-PH-translations" */
          "./translations.json-en-PH-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJKb2IgaW5mb3JtYXRpb24iOiJKb2IgaW5mb3JtYXRpb24ifQ==!"
        )
      ),
"en-SG": createLanguage(
        require.resolveWeak("./translations.json-en-SG-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJKb2IgaW5mb3JtYXRpb24iOiJKb2IgaW5mb3JtYXRpb24ifQ==!"),
        () => import(
          /* webpackChunkName: "en-SG-translations" */
          "./translations.json-en-SG-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJKb2IgaW5mb3JtYXRpb24iOiJKb2IgaW5mb3JtYXRpb24ifQ==!"
        )
      ),
"en-TH": createLanguage(
        require.resolveWeak("./translations.json-en-TH-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJKb2IgaW5mb3JtYXRpb24iOiJKb2IgaW5mb3JtYXRpb24ifQ==!"),
        () => import(
          /* webpackChunkName: "en-TH-translations" */
          "./translations.json-en-TH-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJKb2IgaW5mb3JtYXRpb24iOiJKb2IgaW5mb3JtYXRpb24ifQ==!"
        )
      ),
"th-TH": createLanguage(
        require.resolveWeak("./translations.json-th-TH-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJKb2IgaW5mb3JtYXRpb24iOiLguILguYnguK3guKHguLnguKXguIfguLLguJkifQ==!"),
        () => import(
          /* webpackChunkName: "th-TH-translations" */
          "./translations.json-th-TH-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJKb2IgaW5mb3JtYXRpb24iOiLguILguYnguK3guKHguLnguKXguIfguLLguJkifQ==!"
        )
      ),
"id-ID": createLanguage(
        require.resolveWeak("./translations.json-id-ID-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJKb2IgaW5mb3JtYXRpb24iOiJJbmZvcm1hc2kgcGVrZXJqYWFuIn0=!"),
        () => import(
          /* webpackChunkName: "id-ID-translations" */
          "./translations.json-id-ID-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJKb2IgaW5mb3JtYXRpb24iOiJJbmZvcm1hc2kgcGVrZXJqYWFuIn0=!"
        )
      ),
"zh-HK": createLanguage(
        require.resolveWeak("./translations.json-zh-HK-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJKb2IgaW5mb3JtYXRpb24iOiJKb2IgaW5mb3JtYXRpb24ifQ==!"),
        () => import(
          /* webpackChunkName: "zh-HK-translations" */
          "./translations.json-zh-HK-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJKb2IgaW5mb3JtYXRpb24iOiJKb2IgaW5mb3JtYXRpb24ifQ==!"
        )
      ),
"en-PSEUDO": createLanguage(
        require.resolveWeak("./translations.json-en-PSEUDO-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJKb2IgaW5mb3JtYXRpb24iOiJbxLTDtsO2w58gw6zDrOC4geC4teC5icaSw7bDtsWZbcyCxIPEg+G5r8Osw6zDtsO24LiB4Li14LmJXSJ9!"),
        () => import(
          /* webpackChunkName: "en-PSEUDO-translations" */
          "./translations.json-en-PSEUDO-virtual.json!=!../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJKb2IgaW5mb3JtYXRpb24iOiJbxLTDtsO2w58gw6zDrOC4geC4teC5icaSw7bDtsWZbcyCxIPEg+G5r8Osw6zDtsO24LiB4Li14LmJXSJ9!"
        )
      )
      });
  
      export { translations as default };
    